<template>
  <div>
    <el-dialog  width="60%" :visible.sync="dialogVisible" @close="closeDialog" slot="title">
      <template slot="title">
        <div>
          <h3>{{title}}</h3>
          <el-divider style="font-weight: bold"></el-divider>
        </div>
      </template>
      <el-form
        :inline="true"
        :model="entity"
        class="demo-form-inline"
        label-width="150px"
        ref="editFormRef"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="表单编号" prop="formNumber">
              <el-input
                :readonly="true"
                v-model="entity.formNumber"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="水工公司:" prop="companyName">
              <el-input
                v-model="entity.companyName"
                placeholder=""
                :readonly="true"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="水工姓名:" prop="name">
              <el-input
                v-model="entity.name"
                placeholder=""
                :readonly="true"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="水工电话:" prop="mobile">
              <el-input
                v-model="entity.mobile"
                placeholder=""
                :readonly="true"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="所在城市:" prop="address">
              <el-input
                v-model="entity.address"
                placeholder=""
                :readonly="true"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="施工详细地址:" prop="detailedConstructionAddress">
              <el-input
                v-model="entity.detailedConstructionAddress"
                placeholder=""
                :readonly="true"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="订单金额:" prop="orderAmount">
              <el-input
                v-model="entity.orderAmount"
                placeholder=""
                :readonly="true"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="订单日期:" prop="orderDate">
              <el-input
                v-model="entity.orderDate"
                placeholder=""
                :readonly="true"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="订单产品明细:" prop="productDetails">
              <el-input
                v-model="entity.productDetails"
                placeholder=""
                :readonly="true"
              ></el-input>
            </el-form-item>
          </el-col>


        </el-row>
        <el-row>
          <el-col class="upload-bg">
            <el-form-item label="附件明细:" prop="productDetails">
              <el-image
                 v-for="item in fileList"
                 class="img"
                 :src="item"
                 :preview-src-list="fileList">
               </el-image>
            </el-form-item>
             
           <!-- <el-upload
              action=""
              disabled
              :file-list="fileList"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :limit = "fileList.length"
              :on-remove="handleRemove">
               <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="imgDialogVisible" :append-to-body="true">
              <img v-show="imgDialogVisible" width="80%" :src="dialogImageUrl" alt="">
             </el-dialog> -->
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">Close</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>


export default {
  components: {
  },
  props: {
    dialogTableVisible: {
      type: Boolean,
      default() {
        return false
      },
    },
    agentId:{
      default:''
    },
    title:{
      type:String,
      default(){
        return 'Plumber Order Detail'
      }
    },
    entity:{
      type:Object,
      default(){
        return {

        }
      }
    }
  },
  computed: {
    fileList(){
      console.log("this.entity:", JSON.stringify(this.entity))
      if(this.entity && this.entity.photograph){
        return this.entity.photograph.split(",")
      }
      return [];

    }

  },

  data() {
    return {

      dialogVisible: this.dialogTableVisible,
        //角色列表
      roleList:[],

      imgDialogVisible: false,
      dialogImageUrl: "",
    }
  },
   created(){
    },
  methods: {

    closeDialog() {


      this.$emit('closeDialog')
    },

      handleRemove(file) {
        console.log(file);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.imgDialogVisible = true;
      },


  },
  watch: {
    dialogTableVisible(oldValue, newValue) {
      this.dialogVisible = this.dialogTableVisible
    },
  },
}
</script>

<style lang="less" scoped>
  .upload-bg {

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 12px;

    .img{
      width: 100px;
      height: 100px;
      margin: 12px
    }

    /deep/ .el-upload--picture-card{
      display: none;

    }
  }

</style>
